import { useQuery } from "@tanstack/vue-query";
import {
  CategoryType,
  type SearchApiV2SearchSuggestionsGetRequest,
} from "mws-ts-v2-sdk";

import { queries } from "~/queries";

export default function useSearchSuggestions(
  searchTerm: MaybeRefOrGetter<string>,
  enabled: MaybeRefOrGetter<boolean>,
) {
  const platformStore = usePlatformStore();

  const suggestionQueryParams =
    computed<SearchApiV2SearchSuggestionsGetRequest>(() => ({
      xPlatformKey: platformStore.getPlatformConfiguration.platformId,
      numberOfSuggestions: 5,
      searchTerm: toValue(searchTerm),
      categoryTypes: platformStore.getPlatformConfiguration.isAuctionsEnabled
        ? undefined
        : [CategoryType.Athlete, CategoryType.Team],
    }));

  const { data: suggestions } = useQuery({
    ...queries.search.suggestions(suggestionQueryParams),
    enabled,
  });

  return {
    suggestions,
  };
}
